import { JourneyChoiceGrid as ChoiceGrid } from "../../controls";
import { RIGHT_TO_WORK_OPTIONS } from "../../options";

export const RightToWorkStep = ({ answers, update }) => (
  <div>
    <h2 className="font-display text-3xl font-bold tracking-tight text-ink">Do you currently have the right to work in the UK?</h2>
    <p className="mt-2 text-sm leading-6 text-slatey">Apprenticeships are employment-based, so this apprenticeship needs to know. Self-declaration is indicative only.</p>
    <div className="mt-6"><ChoiceGrid options={RIGHT_TO_WORK_OPTIONS} value={answers.right_to_work} onChange={(v) => update("right_to_work", v)} testId="journey-right-to-work" /></div>
  </div>
);
